import React, { useState } from 'react'
import { userTypes, studentRelationDropdown } from 'views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/utils';
import { useWizard } from 'components/wizard/WizardContext';
import EyeIcon from "assets/img/svg/svgComponents/EyeIcon";
import { EMPTY_FORM } from "../bankDetails/utils";
import AddEditBankAccountDialog from '../bankDetails/AddEditBankAccountDialog';
import BankDetailsCard from '../bankDetails/BankDetailsCard';
import { bankAccountTypes } from "../bankDetails/utils"
import AAccordion from 'components/AAccordion/AAccordion';
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import styles from "../styles.module.scss";
const _ = require("lodash");


const LinkedBankAccount = () => {
    const { values, dropdowns, next } = useWizard();
    const { allBanks, allCountries } = dropdowns?.data;
    const { vendorDetails } = values;
    const [addEditBankDetailsInfo, setAddEditBankDetailsInfo] = useState({});
    const [expanded, setExpanded] = React.useState(true);



    const getSelectedBank = (bankName, allBanksArray = allBanks) => {
        if (!bankName) return null;

        let bank = allBanksArray.find(
            b => b?.bankName?.toLowerCase() === bankName?.toLowerCase()
        );

        if (!bank) {
            bank = allBanksArray.find(
                b => b?.bankName?.toLowerCase()?.includes(bankName?.toLowerCase())
            );
        }

        return bank || null;
    };

    const vendorBankDetails = vendorDetails?.bankAccount
        ? {
            id: vendorDetails?.id,
            bankAccount: vendorDetails?.bankAccount,
            accountHolderName: vendorDetails?.accountHolderName,
            accountType: vendorDetails?.accountType,
            bankName: vendorDetails?.bankName,
            ifsc: vendorDetails?.ifsc,
            status: vendorDetails?.status,
            bankBranch: vendorDetails?.bankBranch,
            bankDetails: getSelectedBank(vendorDetails?.bankName, dropdowns?.data?.allBanks)
        }
        : null;






    const editAccountDetails = (details) => {

        // const { allBanks, allCountries } = dropdowns?.data;
        const accountDetails = _.pick(details, Object.keys(EMPTY_FORM))
        const { accountType, bankName } = details;
        const selectedBank = getSelectedBank(details?.bankName, allBanks);


        setAddEditBankDetailsInfo({
            isOpen: true,
            viewOnly: true,
            initialForm: {
                ...accountDetails,
                bankName: selectedBank,
                country: { label: "INDIA", value: "IND" },
                accountType: bankAccountTypes?.find(type => type?.value === accountType?.toLowerCase()),
                ifsc: details?.ifsc,
                accountHolderName: details?.accountHolderName,
                bankAccount: details?.bankAccount,
            }
        })
    }


    return (
        <>
            <AAccordion expandIcon={<DownArrow />}
                customStyles={{ margin: "20px" }}
                expanded={expanded}
                onChange={(val) => setExpanded(val)}
            >
                <div className={`m-0 ${styles['label']}`}>Vendor payment account</div>
                {vendorBankDetails && (
                    <BankDetailsCard
                        accountDetails={vendorBankDetails}
                        iconClickHandler={() => editAccountDetails(vendorBankDetails)}
                        openDetailsDialogIcon={<EyeIcon />}
                    />
                )}
            </AAccordion>

            <AddEditBankAccountDialog
                dialogInfo={addEditBankDetailsInfo}
                setDialogInfo={setAddEditBankDetailsInfo}
                dropdownData={dropdowns?.data}
            />
        </>
    )
}

export default LinkedBankAccount